import {
  CustomWorkflowContext,
  CustomWorkflowFileReference,
  CustomWorkflowInputField,
  CustomWorkflowInputFieldValue,
  CustomWorkflowJsonValue,
  CustomWorkflowRunInputValue,
} from '../../store/customWorkflow/customWorkflows'

interface RunInputContext {
  context: CustomWorkflowContext
  formValues: Record<string, string>
  fileValues: Record<string, CustomWorkflowFileReference | CustomWorkflowFileReference[]>
}

export const isUserFacingField = (field: CustomWorkflowInputField): boolean => !field.hidden && field.type !== 'json_object'

const fieldDefault = (field: CustomWorkflowInputField): string => (field.default !== null && field.default !== undefined ? String(field.default) : '')

const asStringContext = (value: CustomWorkflowJsonValue | undefined): string | undefined => {
  if (typeof value === 'string') {
    return value
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  return undefined
}

const toInputValue = (field: CustomWorkflowInputField, raw: string): CustomWorkflowInputFieldValue => {
  if (field.type === 'number') {
    return raw === '' ? '' : Number(raw)
  }
  return raw
}

export const buildRunInputs = (
  fields: CustomWorkflowInputField[],
  { context, formValues, fileValues }: RunInputContext,
): Record<string, CustomWorkflowRunInputValue> => {
  const inputs: Record<string, CustomWorkflowRunInputValue> = {}
  for (const field of fields) {
    if (field.type === 'file' || field.type === 'file-list') {
      const reference = fileValues[field.variable]
      if (reference !== undefined) {
        inputs[field.variable] = reference
      }
      continue
    }
    if (field.type === 'json_object') {
      const value = context[field.variable]
      if (value !== undefined) {
        inputs[field.variable] = value
      }
      continue
    }
    const contextValue = asStringContext(context[field.variable])
    const raw = field.hidden ? (contextValue ?? formValues[field.variable] ?? fieldDefault(field)) : (formValues[field.variable] ?? fieldDefault(field))
    inputs[field.variable] = toInputValue(field, raw)
  }
  return inputs
}
